import React from 'react';
import PropTypes from 'prop-types';
import getDisplayName from 'utils/getDisplayName';
import LoadingSpinner from './loadingSpinner';

export default (WrappedComponent) => {
  const Loader = ({ loading, ...props }) => (
    loading ? <LoadingSpinner /> : <WrappedComponent {...props} />
  );

  Loader.propTypes = {
    loading: PropTypes.bool.isRequired,
  };

  Loader.defaultProps = {
    loading: false,
  };

  Loader.displayName = getDisplayName('Loader', WrappedComponent);

  return Loader;
};
